import { render } from "./PhotoWall.vue?vue&type=template&id=2cd92fc4&scoped=true"
import script from "./PhotoWall.vue?vue&type=script&lang=js"
export * from "./PhotoWall.vue?vue&type=script&lang=js"

import "./PhotoWall.vue?vue&type=style&index=0&id=2cd92fc4&scoped=true&lang=css"

import exportComponent from "/Users/michelnussbaum/Documents/WS/luisvue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd92fc4"]])

export default __exports__